import {
  Component,
  Inject,
  Injector,
  ElementRef,
  forwardRef,
  OnInit,
  NgModule,
  HostListener,
  ViewEncapsulation
} from '@angular/core';

import { MdIconModule } from '@angular/material';
import { OBarMenuModule, OBarMenuComponent } from './o-bar-menu.component';
import { OTranslateService } from '../../services';

import { OSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';

export const DEFAULT_INPUTS_O_BAR_MENU_GROUP = [
  // title [string]: menu group title. Default: no value.
  'groupTitle: title',

  // tooltip [string]: menu group tooltip. Default: 'title' value.
  'tooltip',

  // icon [string]: material icon. Default: no value.
  'icon'
];


export class OBarMenuGroupComponent implements OnInit {

  public static DEFAULT_INPUTS_O_BAR_MENU_GROUP = DEFAULT_INPUTS_O_BAR_MENU_GROUP;

  protected menu: OBarMenuComponent;
  protected translateService: OTranslateService;

  protected _groupTitle: string;
  protected _tooltip: string;
  protected _icon: string;
  protected _id: string;

  protected _isHovered: boolean = false;

   onMouseover = () => this.isHovered = true;
   onMouseout = () => this.isHovered = false;

  constructor(
     menu: OBarMenuComponent,
    protected elRef: ElementRef,
    protected injector: Injector) {
    this.menu = menu;
    this.id = 'm_' + String((new Date()).getTime() + Math.random());

    this.translateService = this.injector.get(OTranslateService);
  }

  ngOnInit() {
    if (!this.tooltip) {
      this.tooltip = this.groupTitle;
    }
    if (this.translateService) {
      this.translateService.onLanguageChanged.subscribe(() => {
        this.setDOMTitle();
      });
      this.setDOMTitle();
    }
  }

  setDOMTitle() {
    let tooltip = this.translateService.get(this.tooltip);
    this.elRef.nativeElement.setAttribute('title', tooltip);
  }

  get groupTitle(): string {
    return this._groupTitle;
  }

  set groupTitle(val : string) {
    this._groupTitle = val;
  }

  get tooltip(): string {
    return this._tooltip;
  }

  set tooltip(val : string) {
    this._tooltip = val;
  }

  get icon(): string {
    return this._icon;
  }

  set icon(val : string) {
    this._icon = val;
  }

  get id(): string {
    return this._id;
  }

  set id(val : string) {
    this._id = val;
  }

  get isHovered(): boolean {
    return this._isHovered;
  }

  set isHovered(val : boolean) {
    this._isHovered = val;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-bar-menu-group',
  template: `
    <div class="fake-li mat-primary" [class.fake-li-hover]="isHovered">
      <md-icon *ngIf="icon !== undefined" class="o-bar-menu-group-icon mat-24">{{ icon }}</md-icon>
      <label [attr.for]="id" class="toggle">{{ groupTitle | oTranslate }}</label>
      <a class="o-bar-menu-group-title" >{{ groupTitle | oTranslate }}</a>
      <input [attr.id]="id" type="checkbox" />
      <div class="fake-ul mat-primary mat-elevation-z4">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [`
    o-bar-menu-group .fake-ul .o-bar-menu-group-icon{display:inline-block;margin:0px 10px 0px 0px}o-bar-menu-group .fake-ul .o-bar-menu-group-icon ~ .o-bar-menu-group-title{padding-left:0px}o-bar-menu-group .fake-ul .o-bar-menu-group-title{display:inline-block;padding-left:60px}
  `],
  inputs: [
    ...DEFAULT_INPUTS_O_BAR_MENU_GROUP
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OBarMenuComponent, decorators: [{ type: Inject, args: [forwardRef(() => OBarMenuComponent), ] }, ]},
{type: ElementRef, },
{type: Injector, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onMouseover': [{ type: HostListener, args: ['mouseover', ] },],
'onMouseout': [{ type: HostListener, args: ['mouseout', ] },],
};
}


export class OBarMenuGroupModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OBarMenuGroupComponent],
  imports: [OSharedModule, CommonModule, MdIconModule, OBarMenuModule],
  exports: [OBarMenuGroupComponent],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
